module.exports = __webpack_public_path__ + "logo-abicart.72bf132a631171daf576fe84662a4d04.svg";